export default class ReasonManagementModel {
  id?: number | null;

  nome?: string | null;

  tipo?: string | null;

  situacao ?: number | null;
}
